import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCloserLocationsLoading = (isLoading) => {
  return {
    type: actionTypes.SET_CLOSER_LOCATIONS_LOADING,
    payload: isLoading
  }
}
